<template>
  <ShimmerCards v-if="showShimmer" />
  <div
    v-else
    class="nba-non-actionable-link-wrapper"
  >
    <div
      v-for="(staticLinks, key) in staticLinkData"
      :key="key"
    >
      <button
        class="static-link-btn"
        :style="getLinkStyle"
        @click="handleButtonClicked(staticLinks.url)"
      >
        <p
          class="link-text"
          :style="{ ...getFontSizeForResponse('bodyText', false) }"
        >
          {{ staticLinks.label }}
        </p>
        <div class="icon">
          <BaseIcon
            name="NavigateNext"
            height="10px"
            width="12px"
            :fill="getUserChatAndBotLinkColor"
          />
        </div>
      </button>
    </div>
    <div
      v-for="(value, key) in groupedNbaOptions"
      :key="key"
    >
      <p
        class="content-label"
        :style="{ ...getFontSizeForResponse('bodyText', false) }"
      >
        {{ key }}
      </p>
      <div
        v-for="(val, index) in value"
        :key="index"
      >
        <div
          class="nba-link-container"
          :class="{'nba-link-url-container':!(val.image || val.label || val.longText)}"
          @click="handleButtonClicked(val.url)"
        >
          <div
            v-if="val.image"
            class="nba-link-img"
          >
            <img
              :src="val.image"
              width="105px"
              height="70px"
              loading="eager"
              class="nba-img"
            >
          </div> 
          <div
            :style="{ ...getFontSizeForResponse('smallBodyText', false) }"
            class="nba-link-description-container"
            :class="{'nba-link-description-url-container':!(val.image || val.label || val.longText) }"
          >
            <div
              v-if="val.label && val.longText"
              class="nba-title"
            >
              {{ val.label }}
            </div>
            <p
              v-if="val.label && val.longText"
              class="nba-desc-long"
            >
              {{ val.longText }}
            </p>
            <div
              v-else
              class="nba-title"
            >
              {{ val.url }}
            </div>
          </div>
        </div>
      </div>
    </div> 
  </div>     
</template>

<script>
import groupBy from 'lodash/groupBy'
import ShimmerCards from './ShimmerCards.vue'
import BaseIcon from '@/views/BaseIcon.vue';
import fontSizeMixin from '@/mixins/fontSizeMixin'

export default {
	name: 'NonActionableNBALink',
    components: {
        ShimmerCards,
        BaseIcon
    },
    mixins: [fontSizeMixin],
    props:{
        linkData:{
            type: Array,
            default: () => [],
        },
        staticLinkData: {
            type: Array,
            default: () => [],
        }
    },
    data () {
    return {
      timedOut: false,
      timeoutId: ''
    }
    },
    computed: {
       groupedNbaOptions() {
        return groupBy(this.linkData,'type')
       },

       showShimmer(){
        return !(this.linkData?.[0]?.isProcessed || this.timedOut)
       },

       getUserChatAndBotLinkColor() {
        return this.$store.state.widgetConfig?.botResponseBubbleColor || this.$store.state.widgetConfig?.theme?.color || '#4D34E9'
       },
    
       getLinkStyle() {
        return {
          'color': `${this.getUserChatAndBotLinkColor}`
        }
      }
    },
    mounted(){
        const timeout = Number(this.$store.state.clientConfig?.nbaApiTimeout || 5000)
        this.timeoutId = setTimeout(()=>{
            this.timedOut = true
        }, timeout)
    },
    unmounted() {
        this.timeoutId && clearTimeout(this.timeoutId)
    }, 
    methods: {
        handleButtonClicked(url) {
        if (url && !url.match(/^https?:\/\//i)) {
        url = 'https://' + url;
        }
        url && window.open(url, 'noopener', 'noreferrer')
      },
    }
}
</script>
<style lang="scss" scoped>
.static-link-btn {
    display: flex;
    align-items: center;
    border: none;
    background: white;
    padding: 4px 0px;
    cursor: pointer;
    margin-top: 8px;
    width: 100%;
    

    .link-text {
        font-weight: 600;
        text-align: start;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: initial;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }

    .icon {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0px !important;
        height: 24px;
        width: 24px;
        margin-left: 8px;
        background-color: white;
    }
}
.content-label {
    font-weight: 600;
    margin-top: 24px;
    margin-bottom: 10px;
}
.nba-link-container {
    display: flex;
    border: 1px solid var(--standard-grey-cdcdcd-grey, #CDCDCD);
    cursor: pointer;
    margin-bottom: 12px;
    height: 86px;
    overflow: hidden;

    .nba-link-img {
        padding-top: 8px;
        padding-left: 8px;
    }
    .nba-img {
        object-fit: cover;
    }

    .nba-link-description-container {
        display: flex;
        flex-direction: column;
        margin-left: 12px;
        padding: 8px 16px 8px 0;
        width: 100%;
        justify-content: space-evenly;
        align-items: flex-start;
        .nba-title {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: initial;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
        }

        .nba-desc-long {
            color : #6D6D6D;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: initial;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
    }
}
.nba-link-url-container {
    height: 70px;

    .nba-link-description-url-container {
        align-items: flex-start;
    }
}
</style>
